import { LicensesService } from "~/entity/Licenses/api/service";
import {
  ILicenseOrganizationRowApi,
  ILicensesOverviewParams,
} from "~/entity/Licenses/model/schema";

const PAGE_SIZE = 100;

export const fetchAllLicenseOrganizations = async (
  params?: Pick<ILicensesOverviewParams, "licenseType">,
): Promise<ILicenseOrganizationRowApi[]> => {
  const first = await LicensesService.GET.organizations({
    ...params,
    page: 0,
    count: PAGE_SIZE,
  });
  const data = first.data;

  if (data.level !== "organizations") {
    return [];
  }

  const rows = [...data.rows];
  const pageCount = Math.ceil(data.total / PAGE_SIZE);

  if (pageCount <= 1) {
    return rows;
  }

  const rest = [];

  for (let page = 1; page < pageCount; page += 1) {
    rest.push(
      LicensesService.GET.organizations({
        ...params,
        page,
        count: PAGE_SIZE,
      }),
    );
  }

  const responses = await Promise.all(rest);

  responses.forEach((response) => {
    if (response.data.level === "organizations") {
      rows.push(...response.data.rows);
    }
  });

  return rows;
};
